/*
PLEASE USE THE SAMPLE BANNER BLOCK PROVIDED BELOW:

{
    collection: [],
    queries: [],
    link: '',
    bannerImage: '',
    bannerPosition: 1
},

*/ 
document.addEventListener('Searchanise.Loaded', function () {
    (function ($) {
        // change the products per row count for summer essentials collection
        if (location.pathname.includes('summer-essentials') ) {
            $('body').addClass('snize-summer-collection');
        }
        function snizeAddCollectionBanner(snizeColUrl, snizeBannerUrl, snizeBannerPosition, snizeCurrentUrl, snizeCurrentQuery, container) {
            if (location.pathname.includes('/pages/search-results-page') && snizeCurrentQuery.length) {
                let urlParams = new URLSearchParams(window.location.search);
                let paramsQuery = urlParams.get('q');
                for (let query of snizeCurrentQuery) {
                    if (paramsQuery == query) {
                        const bannerHTML = snizeColUrl
                            ? `<li class="snize-banner snize-custom-banner"><a href="${snizeColUrl}" target="_blank"><img src="${snizeBannerUrl}" alt="Banner"></a></li>`
                            : `<li class="snize-banner snize-custom-banner"><img src="${snizeBannerUrl}" alt="Banner"></li>`;

                        $(`ul.snize-search-results-content li:nth-child(${snizeBannerPosition})`).before(bannerHTML);

                        break;
                    }
                }
            } else if (!location.pathname.includes('/pages/search-results-page') && snizeCurrentUrl.length) {
                for (let url of snizeCurrentUrl) {
                    if ($(location).attr('href').includes(url)) {
                        const bannerHTML = snizeColUrl
                         ? `<li class="snize-banner snize-custom-banner"><a href="${snizeColUrl}" target="_blank"><img src="${snizeBannerUrl}" alt="Banner"></a></li>`
                         : `<li class="snize-banner snize-custom-banner"><img src="${snizeBannerUrl}" alt="Banner"></li>`;

                        $(`ul.snize-search-results-content li:nth-child(${snizeBannerPosition})`).before(bannerHTML);

                        break;
                    }
                }
            }
        }

        let snizeBannersDataEn = [
            {
                collection: ['https://vivierskin.com/collections/fan-favourites', '/collections/vitamin-c', '/collections/serums', '/collections/moisturizers', '/collections/cleansers-toners'],
                queries: ['Serum', 'Quiz', 'Anti aging', 'C E Peptides', 'Radiance'],
                link: '',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0072/7387/3453/files/US_2.jpg?v=1764170377',
                bannerPosition: 5
            },
            {
                collection: ['https://vivierskin.com/collections/anti-aging', '/collections/all', '/collections/acne-treatment'],
                queries: ['Serum', 'Quiz', 'Anti aging', 'C E Peptides', 'Radiance'],
                link: 'https://vivierskin.com/collections/fan-favourites',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0072/7387/3453/files/US_CC_3.jpg?v=1764170377',
                bannerPosition: 5
            },
            {
                collection: ['https://vivierskin.com/collections/luxury-skincare-under-100'],
                queries: ['Serum', 'Quiz', 'Anti aging', 'C E Peptides', 'Radiance'],
                link: 'https://vivierskin.com/products/vivier-gift-card?variant=40839854063774',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0072/7387/3453/files/Holiday_Self_Care_Gift_Set.jpg?v=1763143592',
                bannerPosition: 5
            },
            {
                collection: ['collections/summer-essentials'],
                queries: [''],
                link: '',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0072/7387/3453/files/Prepare_collection_card_-_EN_3214b142-cb27-45fe-9d59-b9209f07686a.png?v=1747838441',
                bannerPosition: 1
            },
            {
                collection: ['collections/summer-essentials'],
                queries: [''],
                link: '',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0072/7387/3453/files/Target_collection_card_-_EN_25de9d48-db0d-4747-a743-18c20e9bb963.png?v=1747838441',
                bannerPosition: 5
            },
            {
                collection: ['collections/summer-essentials'],
                queries: [''],
                link: '',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0072/7387/3453/files/Moisturize_collection_card_-_EN_f34355de-2fc8-4e5b-a270-e8489e4112a1.png?v=1747838441',
                bannerPosition: 9
            },
            {
                collection: ['collections/summer-essentials'],
                queries: [''],
                link: '',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0072/7387/3453/files/Protect_collection_card_-_EN_f3e561e6-9e2c-44a9-adf5-fe88c458464d.png?v=1747838441',
                bannerPosition: 13
            },
        ];
  
        $(document).on('Searchanise.ResultsUpdated', function (e, container) {
            let snizeBannersData = Shopify.locale == 'en' ? snizeBannersDataEn : snizeBannersDataFr;
            if (!$('.snize-custom-banner', container).length) {
                snizeBannersData.forEach(function (bannerData) {
                    snizeAddCollectionBanner(bannerData.link, bannerData.bannerImage, bannerData.bannerPosition, bannerData.collection, bannerData.queries, container);
                });
            }
        });
    })(window.Searchanise.$);
});